import { render } from "./DeletedTests.vue?vue&type=template&id=2b7149dd&scoped=true"
import script from "./DeletedTests.vue?vue&type=script&lang=js"
export * from "./DeletedTests.vue?vue&type=script&lang=js"

import "./DeletedTests.vue?vue&type=style&index=0&id=2b7149dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7149dd"]])

export default __exports__